export default {"src":"https://static.eleduck.com/_next/static/media/error-500.031a6898.svg","height":306,"width":316,"blurWidth":0,"blurHeight":0};